export const Validation = (field, regEx) => {
    let regExData = new RegExp(regEx);
    if (regExData.test(field))
        return true;
    return false;
}
